import { createFileRoute } from '@tanstack/react-router'
import { BoardPage } from '~/features/operations/BoardPage'
import { boardQuery } from '~/features/operations/queries'
import { Gate, RouteError } from '~/features/operations/shared'
import { mayRead } from '~/features/org/guard'

export const Route = createFileRoute('/_app/verein/vorstand/')({
  loader: async ({ context }) => {
    if (await mayRead(context.queryClient, 'ops.read')) await context.queryClient.ensureQueryData(boardQuery())
  },
  component: () => (
    <Gate permission="ops.read">
      <BoardPage />
    </Gate>
  ),
  errorComponent: RouteError,
})
